const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "19%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "8%"
  },
  {
    key: "exhaustTemperature",
    zh: "排气温度(℃)",
    en: "Exhaust Temperature(℃)",
    width: "10%",
    tooltip: true
  },
  {
    key: "inletTemperature",
    zh: "进气温度(℃)",
    en: "Inlet Temperature(℃)",
    width: "10%",
    tooltip: true
  },
  {
    key: "motorBearingTemperature",
    zh: "电机轴承温度(℃)",
    en: "Motor Bearing Temperature(℃)",
    width: "10%",
    tooltip: true
  },
  {
    key: "motorWindingTemperature",
    zh: "电机绕组温度(℃)",
    en: "Motor Winding Temperature(℃)",
    width: "10%",
    tooltip: true
  },
  {
    key: "runTime",
    zh: "累积运行时间(h)",
    en: "Run Time(h)",
    width: "10%",
    tooltip: true
  },
  {
    key: "duration",
    zh: "持续时间(h)",
    en: "Duration(h)",
    width: "9%",
    tooltip: true
  }
]

export default columns